import React, { useState, useContext } from 'react'
import { useLocation, useNavigate, Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Paper, Toolbar, Typography, Avatar, Badge } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet } from 'react-router-dom';
import { AuthContext } from '../../AuthProvider';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import logoMinistere from "../../assets/logo_officiel.png"
import userProfile from "../../assets/userProfile.jpg"
import { grey } from '@mui/material/colors';
import MailLockIcon from '@mui/icons-material/MailLock';
import BarChartIcon from '@mui/icons-material/BarChart';

const drawerWidth = 240;
const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));
function AdminLayout(props) {
    const location = useLocation()
    const { logOut, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [open, setOpen] = useState(true);
    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };
    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };
    const handleSignOut = () => {
        logOut()
            .then(() => {
                navigate("/login"); // Redirect to the login page after logout
            })
            .catch((error) => console.error(error));
    };
    const drawer = (
        <div component="nav">
            <Toolbar sx={{
                bgcolor: '#d82967',
                border: '1px solid #d82967'
            }} >
                {/* <Avatar src={logoMinistere} /> */}
                <img src={logoMinistere} width={60} height={60} style={{background:'white',borderRadius:'50px'}} />
                <Typography variant="h6" noWrap component="div" sx={{ margin: 2,color:'white' }}>
                    MSANP
                </Typography>
            </Toolbar>
            <Divider />
            <Toolbar>
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    variant="dot"
                >
                    <Avatar alt="Remy Sharp" src={userProfile} />
                </StyledBadge>
                <Typography variant="h6" noWrap component="div" sx={{ margin: 2 }}>
                    {user.displayName}
                </Typography>
            </Toolbar>
            <Divider />
            <List style={{ marginTop: 4 }} >
                <ListItem disablePadding selected={location.pathname == '/admin/' || location.pathname == '/admin' || location.pathname == '/admin/statistique'}>
                    <ListItemButton component={Link} to='/admin'>
                        <ListItemIcon>
                            <BarChartIcon />
                        </ListItemIcon>
                        <ListItemText primary='Statistique' />
                    </ListItemButton>
                </ListItem>
                {user && user.type == 'Responsable Centrale' && (
                    <ListItem disablePadding selected={location.pathname == '/admin/doleance'}>
                        <ListItemButton component={Link} to='/admin/doleance'>
                            <ListItemIcon>
                                <MailLockIcon />
                            </ListItemIcon>
                            <ListItemText primary='Doleance' />
                        </ListItemButton>
                    </ListItem>
                )}
                {user && user.type == 'Admin' && (
                    <>
                        <ListItem disablePadding selected={location.pathname == '/admin/region'}>
                            <ListItemButton component={Link} to='/admin/region'>
                                <ListItemIcon>
                                    <LocationOnIcon />
                                </ListItemIcon>
                                <ListItemText primary='Province' />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding selected={location.pathname == '/admin/chu'} >
                            <ListItemButton component={Link} to='/admin/chu'>
                                <ListItemIcon>
                                    <AddHomeWorkIcon />
                                </ListItemIcon>
                                <ListItemText primary='CHU' />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding selected={location.pathname == '/admin/services'}>
                            <ListItemButton component={Link} to='/admin/services'>
                                <ListItemIcon>
                                    <MedicalInformationIcon />
                                </ListItemIcon>
                                <ListItemText primary='Service' />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding selected={location.pathname == '/admin/users'} >
                            <ListItemButton component={Link} to='/admin/users'>
                                <ListItemIcon>
                                    <GroupAddIcon />
                                </ListItemIcon>
                                <ListItemText primary='Utilisateur' />
                            </ListItemButton>
                        </ListItem>
                    </>
                )}
                {user && user.chu_id != null && (
                    <>
                        <ListItem disablePadding selected={location.pathname == '/admin/reservation' || location.pathname == '/admin/addReservation'|| location.pathname.startsWith('/admin/ticket')}>
                            <ListItemButton component={Link} to='/admin/reservation' >
                                <ListItemIcon>
                                    <EventAvailableIcon />
                                </ListItemIcon>
                                <ListItemText primary='Reservation' />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding selected={location.pathname == '/admin/chuService'}>
                            <ListItemButton component={Link} to='/admin/chuService'>
                                <ListItemIcon>
                                    <MedicalInformationIcon />
                                </ListItemIcon>
                                <ListItemText primary='Service' />
                            </ListItemButton>
                        </ListItem>
                    </>

                )}
            </List>
            <Divider />
            <List>
                <ListSubheader component="div" inset sx={{ background: grey[200] }}>
                    Accès aux comptes
                </ListSubheader>
                <ListItem disablePadding selected={location.pathname == '/admin/profile'} >
                    <ListItemButton component={Link} to='/admin/profile'>
                        <ListItemIcon>
                            <ManageAccountsIcon />
                        </ListItemIcon>
                        <ListItemText primary='Mon compte' />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding onClick={handleSignOut}>
                    <ListItemButton>
                        <ListItemIcon>
                            <LogoutIcon color='error' />
                        </ListItemIcon>
                        <ListItemText primary='Deconnecter' />
                    </ListItemButton>
                </ListItem>
            </List>
        </div>
    )
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex', bgcolor: grey[200] }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{
                    width: { md: `calc(100% - ${drawerWidth}px)` },
                    ml: { md: `${drawerWidth}px` },
                    bgcolor: '#d82967'
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { md: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        sx={{ mr: 2, mt: 1, display: { xs: 'none', sm: 'none', md: 'block' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        GESTION RENDEZ-VOUS EN LIGNE
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
                aria-label="mailbox folders"
            >
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'block', md: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            bgcolor: grey[200]
                        },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'none', md: 'block', mt: 1 },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            bgcolor: grey[200]
                        },

                    }}
                    open={open}
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    minHeight: '100vh'
                }}
            >
                <Toolbar />
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'auto',
                    }}
                >
                    <Outlet />
                </Paper>
            </Box>
        </Box>
    )
}
AdminLayout.propTypes = {
    window: PropTypes.func,
};

export default AdminLayout